import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 32, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`masked-line ${className}`}>
      <motion.span
        initial={{ y: "112%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Eyebrow({ children, dark = false }) {
  return (
    <div className="flex items-center gap-3 mb-6" data-testid="section-eyebrow">
      <span className="h-px w-10 bg-gold" />
      <span className={`text-xs font-semibold uppercase tracking-[0.25em] ${dark ? "text-gold" : "text-gold-700"}`}>
        {children}
      </span>
    </div>
  );
}
